<template>
    <div style="display: block" class="pl-2 doc-col" >
        <div class="doc-info v-flex">
            <!-- unit chip -->
            <div v-if="document.unitName" class="doc-unit mr-1 primary white--text">
                <div style="margin-top: -2px">
                    {{ document.unitName }}
                </div>
            </div>
            <!-- unit chip -->

            <!-- bid chip -->
            <div v-if="document.bidId" class=" mr-1">
                {{ bidname }}
            </div>
            <!-- bid chip -->

            <!-- document type -->
            <div class=" mr-1">
                {{ document.type ? document.type.name : '---'}}
            </div>
            <!-- document type -->

            <v-spacer />
        </div>

        <div class="doc-subinfo doc-filename">
            {{ document.name }}
        </div>
    </div>
</template>

<script>
export default {
    name: "PDmsEntryCard",

    props: {
        document: {

        }
    },

    computed: {
        bidname () {
            return this.$t("repair.bid.name." + this.document.bidName);
        },
    }
}
</script>

<style scoped>

.doc-info {
    font-size: 14px;
    padding-top: 1px;
}

.doc-col {
    padding-top: 6px;
    padding-bottom: 3px;
}

.doc-date {
    font-size: 12px;
    margin-top: 4px;
}

.doc-subinfo {
    font-size: 11px;
    margin-top: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.doc-filename {
    max-width: 330px;
    width: 330px;
}

.doc-filename-compact {
    max-width: 220px;
    width: 200px;
}

.doc-unit {
    font-size: 12px;
    padding-left: 8px;
    padding-right: 8px;
    height: 18px;
    margin-top: 2px;
    min-width: 80px;
    text-align: center;
    border-radius: 2px;
}

.menu-icon {
    width: 30px;
    min-width: 30px;
    text-align: left;
}


.top-border-radius {
    border-radius: 8px 8px 0 0!important;
    border-bottom-style: none;
}

.bottom-border-radius {
    border-radius: 0 0 8px 8px!important;
    margin-top: -2px;
}

.top-bottom-border-radius {
    border-radius: 8px 8px 8px 8px!important;
}

.middle-border-radius {
    border-radius: 0 0 0 0!important;
    margin-top: 0px;
    border-bottom-style: none!important;
}

</style>